import {Component, OnInit, OnDestroy} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-escalate-support-group',
  templateUrl: './escalate-support-group.component.html',
  styleUrls: ['./escalate-support-group.component.css']
})
export class EscalateSupportGroupComponent implements OnInit, OnDestroy {

    displayed = true;
    name: string;
    clientId: number;

    add = false;
    del = false;
    edit = false;
    view = false;

    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    types = [];
    private notifier: NotifierService;
    typeSelected: number;
    type: string;
    ttypes = [];
    categories = [];
    defaultValue: string;
    categorySelected: number;
    private category: any;
    toSupportGroup = [];
    forSupportGroup = [];
    toSupportGroupName: string;
    forSupportGroupName: string;
    selectToSupportGroup: number;
    selectForSupportGroup: number;
    private groupName: string;
    escalated: any;
    priority: any;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    ticketSelected: number;
    ticketType: string;
    escalationEmailTime: any;
    additionalEmail: string;
    subject: string;
    editorValue: string;
    priorities = [];
    prioritySelected = 0;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                          item.user_id = this.messageService.getUserId();
                          this._rest.updateEscalationSupportGroup(item).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                              // console.log('data--Done');
                              this.notifier.notify('success', 'Updated successfully');
                            } else {
                              // console.log('data--Not---Done');
                              this.notifier.notify('error', this.respObject.errorMessage);
                            }
                          }, (err) => {
                            this.notifier.notify('error', this.messageService.SERVER_ERROR);
                          });
                        }
                    }
                    break;
                case 'delete':
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteEscalationSupportGroup({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
    }


    ngOnInit() {
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Escalate Support Group',
            openModalButton: 'Add Escalate Support Group',
            breadcrumb: 'Escalate Support Group',
            folderName: 'All Escalate Support Group',
            tabName: 'Escalate Support Group'
        };
        this.typeSelected = 1;

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {id: 'id', name: 'Id', field: 'id', minWidth: 10, sortable: true, filterable: true},
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', minWidth: 30, sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'categoryName', sortable: true, filterable: true
            },
            {
                id: 'forSupportGroup', name: 'For Support Group', field: 'forSupportGroup', sortable: true, filterable: true
            },
            {
                id: 'toSupportGroup', name: 'To Support Group', field: 'toSupportGroup', sortable: true, filterable: true
            },
            {
                id: 'additionalEmail', name: 'Additional Email', field: 'extra_mail_id', sortable: true,
                filterable: true, cssClass: 'highlight', editor: { model: CustomInputEditor }
            },
            {
                id: 'emailTime', name: 'Escalation Email Time', field: 'escalation_time_after_creation', minWidth: 30, sortable: true,
                filterable: true, cssClass: 'highlight', editor: { model: CustomInputEditor }
            },
            {
                id: 'subject', name: 'Subject', field: 'notification_subject', minWidth: 30, sortable: true,
                filterable: true
            },
            {
                id: 'priority', name: 'Priority', field: 'priority', minWidth: 30, sortable: true,
                filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        this.messageService.setGridWidth(1000);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.categorySelected = 0;
            this.typeSelected = 1;
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    save() {
        const data = {
            clientId: this.clientId,
            ticket_type_id: this.ticketSelected, category_id: this.categorySelected,
            to_support_grp: this.selectToSupportGroup, for_support_grp: this.selectForSupportGroup, extra_mail_id: this.additionalEmail,
            escalation_email_time: this.escalationEmailTime, createdBy: this.messageService.getUserId(),
            subject: this.subject, emailBody: this.editorValue, priorityId: this.prioritySelected
        };
        if (!this.messageService.isBlankField(data)) {
            this._rest.insertEscalationSupportGroup(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    const id = this.respObject.details;
                    this.messageService.setRow({id: id, ticketType: this.ticketType, categoryName: this.category,
                        forSupportGroup: this.forSupportGroupName, toSupportGroup: this.toSupportGroupName, additional_email: this.additionalEmail,
                        escalation_time_after_creation: this.escalationEmailTime, notification_subject: this.subject, priority: this.priority});
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.escalated = '';
                    this.categorySelected = 0;
                    this.ticketSelected = 0;
                    this.toSupportGroup = [];
                    this.forSupportGroup = [];
                    this.escalationEmailTime = '';
                    this.subject = '';
                    this.editorValue = '';
                    this.prioritySelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this._rest.getEscalationSupportGroup(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    onTicketChange(selectedIndex: any) {
        this.ticketType = this.ttypes[selectedIndex].name;
        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Category'});
                this.categories = this.respObject.details;
                this.categorySelected = 0;
            } else {
                this.categories = [];
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

        this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onCategoryChange(selectedIndex) {
        this.category = this.categories[selectedIndex].name;
        this._rest.getSupportGroupByCategory(this.clientId, this.categorySelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select support group'});
                this.toSupportGroup = this.respObject.details;
                this.selectToSupportGroup = 0;

                this.forSupportGroup = this.respObject.details;
                this.selectForSupportGroup = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    forSupportGroupChange(selectedIndex) {
        this.forSupportGroupName = this.categories[selectedIndex].name;
    }

    toSupportGroupChange(selectedIndex) {
        this.toSupportGroupName = this.categories[selectedIndex].name;
    }

    onPriorityChange(selectedIndex) {
        this.priority = this.priorities[selectedIndex].name;
    }

}
